export default __webpack_public_path__ + "static/media/minor_custodial_account_light.647d23ad.png";